import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { INotify } from "../../model/user-info.interface";
import { INotificationsState } from ".";

export interface IMarkNotifyAsReadResponse {
    notifications: INotify[];
}

export const getNotifications = createAsyncThunk<IMarkNotifyAsReadResponse>(
    'notifications/getNotifications',
    async () => await api.notifications.get()
);

const getNotificationsHandler = (builder: ActionReducerMapBuilder<INotificationsState>) => {
    builder
        .addCase(getNotifications.pending, (state: INotificationsState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(getNotifications.fulfilled, (state: INotificationsState, action: PayloadAction<IMarkNotifyAsReadResponse>) => {
            state.loading = false;
            state.items.push(...action.payload.notifications);
        })
        .addCase(getNotifications.rejected, (state: INotificationsState) => {
            state.loading = false;
            state.error = 'Unable to get notifications';
        });
};

export default getNotificationsHandler;